import React from 'react';
import {Heading} from '../../Common/Heading';
import Eyebrow from '../../Common/Eyebrow';
import {Col, Properties, Property, Row} from '../../Common/Property';
import {CodeGroup} from '../../Common/Code';

export default function Vouchers() {
	return (
		<>
			<h1>All Expenses</h1>
			<p className='lead mb-10'>
				As the name suggests, this page is related to fetch all expenses done in given timeline.
			</p>
			<Heading level={2}>Fetch Expenses</Heading>
			<div className='lead mb-8'>
				This api is for fetching all expenses between a certain timeframe.
			</div>
			<Eyebrow
				label='https://provider.dice.tech/api/v1/expenses/expenses'
				tag='POST'
			/>
			<div className='mb-6'/>
			<Row>
				<Col>
					<Properties>
						<Property name='startDate' type='timestamp'>
							Start of timeframe to fetch data.
						</Property>
						<Property name='endDate' type='timestamp'>
							End of timeframe to fetch data.
						</Property>
					</Properties>
				</Col>
				<Col>
					<CodeGroup
						tag='POST'
						label='/api/v1/expenses/expenses'
						title='Request Payload'
					>
						<code title='json'>
							{JSON.stringify(
								{
									startDate: 1682983046000,
									endDate: 1685661446000
								},
								null,
								2
							)}
						</code>
					</CodeGroup>
					<CodeGroup title='Response Payload'>
						<code title='json'>
							{JSON.stringify(
								{
									"success": true,
									"transactions": [
										{
											"transId": "10032923050700001",
											"amount": {
												"currency": "INR",
												"amount": 555.0,
												"converted": 555.0
											},
											"reimbursable": {
												"currency": "INR",
												"amount": 555.0,
												"converted": 555.0
											},
											"converted": {
												"currency": "INR",
												"amount": 555.0,
												"converted": 555.0
											},
											"service": "Food",
											"date": 1683397800000,
											"createdAt": 1683451067094,
											"expenseStatus": 1,
											"owner": {
												"id": 240376,
												"ownerType": "EMPLOYEE",
												"ownerId": "167462",
												"ownerName": "Sukesh Shetty",
												"fields": {
													"hr head": "167462",
													"manager": "167462",
													"alternate": "167462",
													"team": "CT LEADS",
													"department": "CT LEADS",
													"doj": "1683016732000"
												}
											},
											"office": {
												"id": 9,
												"name": "CT LEADS"
											},
											"department": {
												"id": 11,
												"name": "CT LEADS"
											},
											"voucherId": "-",
											"transactionType": "SELFPAID",
											"merchant": "No Merchant",
											"refunded": false,
											"fraud": false,
											"seekClarification": false,
											"violation": false,
											"details": "Receipt submitted of INR 555.0 for food."
										}
									]
								},
								null,
								2
							)}
						</code>
					</CodeGroup>
				</Col>
			</Row>
		</>
	);
}
